import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, FAQ} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {getSearchBarVariant} from '@helpers';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import FAQPage from '@components/Static/Faq';
import {useDispatch} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import type {GetServerSidePropsContext} from 'next/types';

type FaqProps = {
  seoConfig: object;
};

const Faq = ({seoConfig}: FaqProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, FAQ);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const breadcrumbElements = [
    {
      name: 'Home',
      item: '/',
    },
    {
      name: 'Frequently Asked Questions',
      item: ``,
    },
  ];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          <FAQPage />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const searchBarVariant = await getSearchBarVariant({req: context.req});
    store.dispatch({
      type: 'AppContext/set_ab_variants',
      payload: {searchBar: searchBarVariant},
    });
    const seoConfig = await loadSEO(FAQ);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: FAQ},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default Faq;
